import {useEffect, useState} from "react"
import {Branding} from "@irati/types"
import BrandingStream from "./streams/branding"

export function useBranding() {
  const [branding, setBranding] = useState<Branding | null>(() => BrandingStream.get())

  useEffect(() => {
    const stream = BrandingStream.subscribe((s) => setBranding(s))
    return () => {
      stream.unsubscribe()
    }
  }, [])

  return branding
}
